ConfigureXeditable.$inject = ['editableOptions'];

function ConfigureXeditable(editableOptions) {
    editableOptions.theme = 'bs3';
    editableOptions.submitButtonTitle = 'Enviar';
    editableOptions.submitButtonAriaLabel = 'Enviar';
    editableOptions.cancelButtonTitle = 'Cancelar';
    editableOptions.cancelButtonAriaLabel = 'Cancelar';
    editableOptions.clearButtonTitle = 'Borrar';
    editableOptions.clearButtonAriaLabel = 'Borrar';
    editableOptions.icon_set = 'font-awesome';
}


export default ConfigureXeditable;